import clsx from 'clsx'

interface FilterItemProps {
  index: number
  label: string
  active?: boolean
  onSelect?: () => void
}

const FilterItem: React.FC<FilterItemProps> = ({ index, label, active = false, onSelect }) => {
  return (
    <div
      className={clsx(
        'py-[10px] px-[16px] border-[1px] inline-block mr-[10px] mb-[10px] rounded-[7px] font-semibold text-sm cursor-pointer',
        active ? 'bg-ivory border-wif-orange text-wif-orange' : 'bg-white border-[#F0F0F0]'
      )}
      data-test={`filter-item-${index}`}
      onClick={onSelect}
    >
      {label}
    </div>
  )
}

export default FilterItem
